module.exports = __webpack_public_path__ + "img/logo-zhitomir.844f5413.png";